<!-- Search bar header -->
<div class="flex-layout top-box">
  <!-- Drive searching use case
  Every drive has 8 ports. It is easier to see all the available ports by filtering by drive
  Typing is easier for this than selecting from a long list since it goes from A-L
  -->
  <div class="search-filters">
    <mat-form-field>
      <mat-label>Drive Letter</mat-label>
      <input matInput placeholder="Drive Letter" [formControl]="filterDriveText">
    </mat-form-field>

    <span>
      <mat-form-field>
        <mat-label>Server Name</mat-label>
        <input matInput placeholder="Server Name" [formControl]="filterServerNameText">
      </mat-form-field>
    </span>

    <mat-checkbox [formControl]="showOnlyDriveReady" class="ml-4">
      Show Only Drive Ready
    </mat-checkbox>
  </div>

  @if (isLoadingData()) {
    <insight-loading-spinner loadingMessage="Updating Drive Delivery data"></insight-loading-spinner>
  } @else {
    <em>Data updates every 15 seconds</em>
  }
</div>

<mat-table [dataSource]="dataSource" matSort>
  <!-- Rush Column. We have the order number in here..but we are going to sort based off the "rush" property to help prioritize -->
  <ng-container matColumnDef="rushOrder">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Order #</mat-header-cell>
    <mat-cell *matCellDef="let status">
      <div class="flex-layout" style="gap: 0.5rem;">
        @if (status.rushOrder) {
          <mat-icon matTooltip="Order is past due. This is a priority to get out." color="primary">flag</mat-icon> {{ status.shipmentNumber }}
        }

        <a target="_blank" [routerLink]="['/order-shipment']" [queryParams]="orderShipmentQueryParams(status)">
          {{status.orderNumber ? status.orderNumber : ''}}
        </a>
      </div>
    </mat-cell>
  </ng-container>

  <!-- Server Column -->
  <ng-container matColumnDef="serverName">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Server</mat-header-cell>
    <mat-cell *matCellDef="let status">
      <label style="word-break: break-word;">{{status.serverName}}</label>
    </mat-cell>
  </ng-container>

  <!-- Drive Column -->
  <ng-container matColumnDef="driveLetter">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Drive</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.driveLetter}}
    </mat-cell>
  </ng-container>

  <!-- Sched. Req Column -->
  <ng-container matColumnDef="scheduleRequired">
    <mat-header-cell *matHeaderCellDef mat-sort-header class="center">Sched. Req</mat-header-cell>
    <mat-cell *matCellDef="let status" class="center">
      <mat-icon class="{{ statusColor(status.scheduleRequired) }}">{{status.scheduleRequired ? 'check_circle' : 'highlight_off'}}</mat-icon>
    </mat-cell>
  </ng-container>

  <!-- Sched. Avail Column -->
  <ng-container matColumnDef="scheduleAvailable">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Sched. Avail</mat-header-cell>
    <mat-cell *matCellDef="let status">
      <mat-icon class="{{ statusColor(status.scheduleAvailable) }}">{{status.scheduleAvailable ? 'check_circle' : 'highlight_off'}}</mat-icon>
    </mat-cell>
  </ng-container>

  <!-- Pub Written Column -->
  <ng-container matColumnDef="publicityWritten">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Pub Written</mat-header-cell>
    <mat-cell *matCellDef="let status">
      <mat-icon class="{{ statusColor(status.publicityWritten) }}">{{status.publicityWritten ? 'check_circle' : 'highlight_off'}}</mat-icon>
    </mat-cell>
  </ng-container>

  <!-- Drive Ready Column -->
  <ng-container matColumnDef="driveReady">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Drive Ready</mat-header-cell>
    <mat-cell *matCellDef="let status">
      <mat-icon class="{{ statusColor(status.driveReady) }}">{{status.driveReady ? 'check_circle' : 'highlight_off'}}</mat-icon>
    </mat-cell>
  </ng-container>

  <!-- Last Updated Column -->
  <ng-container matColumnDef="lastUpdatedDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Last Updated</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.lastUpdatedDate | date: 'short' }}
      <!-- <br/> ({{status.lastUpdatedDate | dateDistanceStrict: currentDate : { addSuffix: true }  }}) -->
    </mat-cell>
  </ng-container>

  <!-- Ship Date Column -->
  <ng-container matColumnDef="shipmentDate">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Ship Date</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.shipmentDate | date: 'shortDate' }}
    </mat-cell>
  </ng-container>

  <!-- Market Column -->
  <ng-container matColumnDef="market">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Market</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.market}}
    </mat-cell>
  </ng-container>

  <!-- Delivery Type Column -->
  <ng-container matColumnDef="deliveryType">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Delivery Type</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.deliveryType}}
    </mat-cell>
  </ng-container>

  <!-- Created By Column -->
  <ng-container matColumnDef="scheduleCreator">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Created by</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{status.scheduleCreator}}
    </mat-cell>
  </ng-container>

  <!-- Notes Column -->
  <ng-container matColumnDef="notes">
    <mat-header-cell *matHeaderCellDef mat-sort-header>Notes</mat-header-cell>
    <mat-cell *matCellDef="let status">
      {{ formatNotes(status.notes) }}
    </mat-cell>
  </ng-container>

  <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
  <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
</mat-table>